import {
  useInventoryFilter,
  type AssetType,
  type Status,
  type InventoryFilter,
} from "./inventory-filter";
import type { Building } from "./api/building";

export type ScopeTags = {
  city?: string;
  type?: Exclude<AssetType, "all">;
  status?: Exclude<Status, "all">;
};

/** Tarkistaa täsmääkö tagi-joukko nykyiseen suodatukseen. */
export function matchesFilter(
  tags: ScopeTags,
  filter: { city: string; type: AssetType; status: Status },
): boolean {
  if (filter.city !== "all" && tags.city && tags.city !== filter.city)
    return false;
  if (filter.type !== "all" && tags.type && tags.type !== filter.type)
    return false;
  if (filter.status !== "all" && tags.status && tags.status !== filter.status)
    return false;
  return true;
}

/** Filters buildings by inventory filter (city/type/status) and optionally a group membership list. */
export function filterBuildings(
  buildings: Building[],
  filter: InventoryFilter,
  groupBuildingIds: string[] | null,
): Building[] {
  return buildings.filter((b) => {
    if (groupBuildingIds !== null && !groupBuildingIds.includes(b.id))
      return false;
    if (filter.city !== "all" && b.city !== filter.city) return false;
    if (filter.type !== "all" && b.building_type !== filter.type) return false;
    if (filter.status !== "all" && b.status !== filter.status) return false;
    return true;
  });
}

/**
 * The inventory-filtered building list for the current scope. Bundles the
 * `useInventoryFilter()` + `filterBuildings(...)` pattern that the activity / findings /
 * recommendations / optimization routes each repeated verbatim. It is a hook, so call it
 * unconditionally — pass `[]` while the source list isn't ready yet.
 */
export function useFilteredBuildings(buildings: Building[]): Building[] {
  const { filter, activeGroup } = useInventoryFilter();
  return filterBuildings(buildings, filter, activeGroup?.building_ids ?? null);
}
